// extracted by mini-css-extract-plugin
module.exports = {"divider-wrapper":"tabs_divider-wrapper_2wv_K"};